import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";

import FormExterno from "../../components/FormExterno";

const Login = () => {

    const [src, setSrc] = useState([])

    useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {

            if (typeof response.data.acesso !== 'undefined') {
                setSrc(response.data.acesso)
            }

        })

    }, []);

    return (
        <div style={{ minHeight: 600 }} id="div_iframe" >

            <Navigation titulo="Login"/>
            
           <FormExterno src={src}/>

        </div>
    )
}

export default Login;
